import type { ComponentChildren } from "preact";
import { ContextGlobal } from "../contexts/ContextGlobal";
import { useLocation } from "@airvantage/ui";
import { useMemo } from "preact/hooks";
import type { Location } from "history";

type ProviderGlobalProps = {
  children: ComponentChildren;
};

export function ProviderGlobal({ children }: ProviderGlobalProps) {
  const location = useLocation();
  const global = useMemo(() => globalFromLocation(location), [location]);
  return (
    <ContextGlobal.Provider value={global}>{children}</ContextGlobal.Provider>
  );
}

function globalFromLocation(location: Location) {
  const params = new URLSearchParams(location?.search);
  return {
    companyUid: params.get("company") ?? undefined,
  };
}
